import React from 'react';

import AboutWrapper from './About.styles';

import Licenses, { LicenseList } from '../../license/Licenses'
import { localization } from '../../localization';
import { Settings } from '../../CommonTypes';
import { Title } from '../measure_ui';

export interface AboutProps {
  licenses: LicenseList;
  settings: Settings;
  requestClose: () => void;

  openLink: (link: string, newTab: boolean) => void;
  logoPath: string;
}

export const About: React.FC<AboutProps> = ({ licenses, settings, logoPath, requestClose, openLink }) => {
  return (
    <AboutWrapper>
      <div id='MainAbout' onClick={() => requestClose() }>
        <div id='AboutBox' onClick={e => e.stopPropagation() }>
          <div id='TitleShower'><Title logoPath={ logoPath } /></div>
          <span>
            <h1>{`${process.env.REACT_APP_VERSION}`}</h1>
            <h2>{localization[settings.lang].by('© 2021', 'strucTEM')}</h2>
            <h2>{localization[settings.lang].by(localization[settings.lang].developed, 'Robin Braun')}</h2>
            <br/>
            <h3>{localization[settings.lang].disclaimer }</h3>
            { localization[settings.lang].disclaimerText }
          </span>
        </div>
      </div>
      <div id='LicensesPane'>
        <Licenses licenses={ licenses } lang={settings.lang} openLink={openLink}/>
      </div>
    </AboutWrapper>
  );
};